import { commonNextEnv } from '@repo/env/client';

export const getAbsoluteUrl = (from: string, baseUrl?: string): string => {
  const isAbsoluteUrl = from.startsWith('http');

  if (isAbsoluteUrl) {
    const { hostname, pathname, search } = new URL(from);
    const base = baseUrl || hostname;

    const url = new URL(`${commonNextEnv().NEXT_PUBLIC_APP_PROTOCOL}://${base}${pathname}${search}`);

    return url.toString();
  }

  const base = baseUrl || commonNextEnv().NEXT_PUBLIC_APP_HOST;

  const url = new URL(from, `${commonNextEnv().NEXT_PUBLIC_APP_PROTOCOL}://${base}`);

  return url.toString();
};
